import React, { useEffect } from 'react'

const PlanOneThankYouPage = () => {
  const themeColor = "#104A52";
  const redirectUrl = "/pro-plans";




  return (
    <>
      <div style={styles.wrapper}>
        <div style={styles.card}>
          {/* Success Icon */}
          <div style={{ ...styles.iconWrapper, backgroundColor: themeColor }}>
            <svg
              width="42"
              height="42"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>

          {/* Content */}
          <h1 style={{ ...styles.heading, color: themeColor }}>
            Thank You for Your Trust!
          </h1>

          <p style={styles.subText}>
            Your <strong>Swasth Pro Plan</strong> has been successfully
            activated. You now have access to quality healthcare, consultations,
            and wellness benefits designed for your peace of mind.
          </p>

          {/* Info Box */}
          <div style={styles.infoBox} className='text-left'>
            <p><i className='fas fa-check mr-2'></i> 3 Credits on Tele Doctor Consultation</p>
            <p><i className='fas fa-check mr-2'></i> Upto 20% Off on Prescribed Pharmacy</p>
            <p><i className='fas fa-check mr-2'></i> Upto 50% Off on Diagnostics</p>
            <p className='mb-0'><i className='fas fa-check mr-2'></i> <strong className='text-[#104A52]'>Free</strong> ₹1 Lakh Personal Accidental Cover for primary member</p>
          </div>

          {/* CTA */}
          <button
            style={{ ...styles.button, backgroundColor: themeColor }}
            onClick={() => (window.location.href = redirectUrl)}
          >
            Go to Home
          </button>
        </div>
      </div>
    </>
  )
}

const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #e8f3f4, #ffffff)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    fontFamily: "'Nunito', sans-serif",
  },
  card: {
    maxWidth: "520px",
    width: "100%",
    background: "#fff",
    borderRadius: "18px",
    padding: "40px 30px",
    textAlign: "center",
    boxShadow: "0 20px 40px rgba(16, 74, 82, 0.15)",
    animation: "fadeIn 0.8s ease-in-out",
  },
  iconWrapper: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    margin: "0 auto 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "12px",
  },
  subText: {
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#555",
    marginBottom: "22px",
  },
  infoBox: {
    background: "#f3f9fa",
    borderRadius: "12px",
    padding: "15px",
    marginBottom: "25px",
    color: "#104A52",
    fontSize: "14px",
    lineHeight: "1.8",
  },
  button: {
    padding: "14px 26px",
    color: "#fff",
    fontSize: "15px",
    borderRadius: "30px",
    border: "none",
    cursor: "pointer",
    fontWeight: "600",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },
  redirectText: {
    marginTop: "14px",
    fontSize: "13px",
    color: "#888",
  },
};

export default PlanOneThankYouPage